module.exports = __webpack_public_path__ + "img/zh_CN-box4-text-dark.ed6347da.png";